/**
 * This code was generated by Builder.io.
 */
import React from "react";
import { Box, Typography } from "@mui/material";
import { getSx } from "./style";
import NotificationsMenu from "./NotificationsMenu";

function Header({ mdScreen, smScreen, heading, collapse }) {
  const classes = getSx(mdScreen, collapse, smScreen, heading);

  return (
    <Box sx={classes.headerContainer}>
      <Typography
        sx={{ textTransform: "capitalize" }}
        variant="h1"
        color="#03293A"
        fontSize="24px"
        fontWeight="500"
      >
        {heading || window.location.pathname.split("/")[1].replace(/-/g, " ")}
      </Typography>
    </Box>
  );
}

export default Header;
